import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import consumer from "../images/consumer.webp";
import professional from "../images/professional.webp";
import pcb from "../images/homepcb.webp";
import smart from "../images/smartlight.webp";

const VerticalCards = () => {
  return (
    <section className="systems-section mt-5 mb-5">
      <Container fluid className="px-0">
        <Row className="g-0">
          {/* Kitchen System */}
          <Col  md={3} className="text-section kitchen-system">
            <a href="/consumer-product" style={{ color: "black", textDecoration: "none" }}>
              <h5>Consumer</h5>
            </a>
            <div className="divider"></div>
            <p>
              Step into a world of premium products crafted for you. Light up
              your life, home, and workspace with our unique and exclusive
              range.
            </p>
          </Col>
          <Col md={3} className="image-section ">
            <img src={consumer} alt="Kitchen System" />
          </Col>

          {/* Wardrobe System */}
          <Col md={3} className="text-section wardrobe-system">
            <a href="/perfessional-product" style={{ color: "black", textDecoration: "none" }}>
              <h5>Professional</h5>
            </a>
            <div className="divider"></div>
            <p>
              With expertise in the professional lighting sector, we’ve crafted
              premium products that redefine illumination enhancing spaces and
              enriching lives with light that truly matters
            </p>
          </Col>
          <Col md={3} className="image-section">
            <img src={professional} alt="Wardrobe System" />
          </Col>

          {/* Bar System */}
          <Col md={3} className="image-section">
            <img src={pcb} alt="Bar System" />
          </Col>
          <Col md={3} className="text-section bar-system">
            <a href="/Ourproduct" style={{ color: "black", textDecoration: "none" }}>
              <h5>PCB</h5>
            </a>
            <div className="divider"></div>
            <p>
              Empower your innovations with high quality, precision engineered
              PCBs reliable, customizable, and designed for peak performance.
            </p>
          </Col>

          {/* Bathroom System */}
          {/* <Col md={3} className="image-section">
            <img src={smart} alt="Bathroom System" />
          </Col>
          <Col md={3} className="text-section bathroom-system">
            <a href="/smartlighting" style={{ color: "black", textDecoration: "none" }}>
              <h5>Smart Lighting</h5>
            </a>
            <div className="divider"></div>
            <p>Control your ambiance with advanced technology.</p>
          </Col> */}
        </Row>
      </Container>
    </section>
  );
};

export default VerticalCards;
